import { render, staticRenderFns } from "./FollowupStatus.vue?vue&type=template&id=6e3ceaa7&scoped=true&"
import script from "./FollowupStatus.vue?vue&type=script&lang=js&"
export * from "./FollowupStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e3ceaa7",
  null
  
)

export default component.exports